module.exports = __webpack_public_path__ + "images/application/test-mode-facd3efd.svg";